import { api } from '../../config/api'

const basePath = 'dashboard/admissoes'

/**
 * Get all
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const getAll = (options) => {
	const options_default = {}

	// Merge config
	options = Object.assign({}, options_default, options)

	let params = []
	let params_qs = ''
	if (options.hasOwnProperty("empresa")) {
		params.push(`empresa=${options.empresa}`);
	}

	if (params.length) {
		params_qs = `?${params.join('&')}`
	}

	return api.get(`${basePath}${params_qs}`)
}
